import { post, xenv } from '@didi/webx-js'
import mpx from '@mpxjs/core'
import { request } from '../api/request'
import { GlobalConfig } from '../config'
import { EnumGoodsDetailIsSpike, EnumOrderDetailType } from '../defines'
import { GlobalEnv } from '../global_env'
import { URLQueries, getUrlBizExtraParams } from '../global_env/url_query'
import { getRiskControlParams } from '../utils/risk_control'
import { isDyProgramH5, isOnline, isPre } from '@/lib/js/env'
import { TechPageErrorDyCreateNoOpenid } from '@/lib/webx/tech_error_track'
import {
  getBizExtraData,
  getCreateOrderSystemParams,
} from '../../../lib/js/util'
import { orderInit } from '@didi/trade-sdk/lib/quartz-mall'

/**
 * 创建普通订单
 * @param {Object} params - 请求参数
 * @param {Object} [options] - 选项
 */
const createOrderNormal = async (params, options) => {
  try {
    mpx.showLoading(
      options && options.loadingText
        ? { icon: 'loading', title: options.loadingText }
        : { icon: 'loading' }
    )
    const data = await request.post(
      GlobalConfig.APIs.createOrderNormal,
      params,
      {
        useFormData: true,
      }
    )
    mpx.hideLoading()
    return data
  } catch (error) {
    mpx.hideLoading()
    return Promise.reject(error)
  }
}

const createOrderGroup = async (params, options) => {
  try {
    mpx.showLoading(
      options && options.loadingText
        ? { icon: 'loading', title: options.loadingText }
        : { icon: 'loading' }
    )
    const _params = params || {}
    // TODO 长期规划让后端下单时校验团状态，但是目前后端方案未定，前端先处理
    // 团失败之后再次发团时需要不需要传入group_id
    if (!options.isCreateNewGroup) {
      _params.group_id = URLQueries.getQuery('groupId')
    }
    const data = await request.post(
      GlobalConfig.APIs.createOrderGroup,
      {
        ...params,
      },
      {
        useFormData: true,
      }
    )
    mpx.hideLoading()
    return data
  } catch (error) {
    mpx.hideLoading()
    return Promise.reject(error)
  }
}
/**
 * 创建代购订单
 * @param {Object} params - 请求参数
 * @param {Object} [options] - 选项
 */
const createOrderProxy = async (params, options) => {
  try {
    mpx.showLoading(
      options && options.loadingText
        ? { icon: 'loading', title: options.loadingText }
        : { icon: 'loading' }
    )
    // const data = await request.postEncrypt(
    const outOpenId = URLQueries.getQuery('open_id') || 'ddddddd'
    if (isDyProgramH5()) {
      const adParams = getUrlBizExtraParams()
      const extra = {
        out_open_id: outOpenId,
        ...adParams,
      }
      params.out_open_id = outOpenId
      params.extra = JSON.stringify(extra)
      const isAnotherOrder = URLQueries.getQuery('another_order')
      if (isAnotherOrder) {
        params.source_id = 'another_order'
      }
    }
    const data = await request.postEncrypt(
      `${GlobalConfig.APIs.createOrderProxy}?token=${params.token}`,
      params,
      {
        useFormData: true,
        header: { 'content-type': 'application/json' },
      }
    )
    if (isDyProgramH5() && outOpenId === 'ddddddd') {
      TechPageErrorDyCreateNoOpenid(data)
    }
    mpx.hideLoading()
    return data
  } catch (error) {
    mpx.hideLoading()
    return Promise.reject(error)
  }
}

/**
 * 下单
 * @param {Object} [params] - 自定义参数
 * @param {Object} [options] - 选项
 * @param {boolean} [options.zeroPrice] - 是否价格为 0
 * @param {string} [options.loadingText] - loading 文案
 */
export const createOrder = async (params, options) => {
  if (!options) {
    options = {}
  }
  Object.assign(options, {
    goodsId: URLQueries.getQuery('id'),
  })
  const { channelId, loginInfo, locationInfo, clientType, terminal } = GlobalEnv
  const env = await getRiskControlParams(true)
  const systemParams = await getCreateOrderSystemParams()
  const _params = Object.assign(
    {
      xenv: xenv(),
      token: loginInfo.token,
      source_id: channelId,
      city_id: locationInfo.cityId - 0,
      goods_id: URLQueries.getQuery('id') - 0,
      client_type: clientType,
      estimate_id: URLQueries.getQuery('estimate_id'),
      pay_mode_id: 0,
      recommender: URLQueries.getQuery('recommender') || '',
      remarks: URLQueries.getQuery('remarks') || '',
      terminal,
      env: JSON.stringify(env),
      ...systemParams,
    },
    params
  )
  _params.goods_id = _params.goods_id - 0
  console.log('----createOrder-params', _params.goods_id, isOnline, isPre)
  _params.extra = JSON.stringify(getBizExtraData().bizOrderData)
  if (isPre || !isOnline) {
    console.log('-----createOrder-params-all', _params)
  }
  const isGroup =
    options && options.orderBySpike === EnumGoodsDetailIsSpike.Group
  try {
    // Tip: 抖音一期只做普通商品代购逻辑，后续秒杀商品要做待购时，需要处理秒杀的接口加密
    const res = isGroup
      ? await createOrderGroup(_params, options)
      : options.postEncrypt
      ? await createOrderProxy(_params, options)
      : await createOrderNormal(_params, options)
    if (!res) {
      return Promise.reject()
    }
    console.log('createOrder=====', res)
    return res
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * 获取订单详情
 * @param {string|number} id - order id 或者 coupon id
 * @param {Object} param - 参数
 * @param {EnumOrderDetailType} param.type - id 类型
 */
export const getOrderDetail = async (
  id,
  { type } = { type: EnumOrderDetailType.Order }
) => {
  if (id === undefined || id === '') {
    throw new Error('获取订单详情需要订单 ID.')
  }
  const params = {
    token: GlobalEnv.loginInfo.token,
    source_id: GlobalEnv.channelId,
    [type === EnumOrderDetailType.Coupon ? 'coupon_id' : 'order_id']: id,
    xenv: xenv(),
    city_id: GlobalEnv.locationInfo.cityId,
    lat: GlobalEnv.locationInfo.lat,
    lng: GlobalEnv.locationInfo.lng,
    needFullData: true,
    noNeedOrderActInfo: true,
    lang: GlobalEnv.lang,
  }
  try {
    const data = await orderInit(id, params)
    console.log('getOrderDetail data', data)
    // const data = await request.get(GlobalConfig.APIs.getOrderInfo, params)
    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * 更新订单信息
 * @param {string} id - 订单 ID， 订单 ID 一定要用字符串，整数类型太长会超过语言整数类型上限
 * @param {Object} options - 选项
 * @param {number} options.type - 操作类型
 * @returns
 */
export const updateOrder = async (id, { type } = {}) => {
  if (id && type) {
    try {
      const params = {
        token: GlobalEnv.loginInfo.token,
        order_id: id,
        op_type: type,
      }
      const data = await request.post(GlobalConfig.APIs.updateOrder, params, {
        useFormData: true,
      })
      return Promise.resolve(data)
    } catch (error) {
      return Promise.reject(error)
    }
  } else {
    throw new Error('操作订单详情需要订单 ID 和 操作类型。')
  }
}
/**
 * 删除订单
 * @param {string} id - 订单 ID
 */
export const cancelOrder = params => {
  if (!params?.order_id || !params?.partition_id) {
    return Promise.reject('操作订单详情需要订单 ID,partition_id')
  }
  return request.post(
    GlobalConfig.APIs.orderClose,
    {
      token: GlobalEnv.loginInfo.token,
      ...params,
    },
    {
      header: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    }
  )
}
/**
 * 获取订单支付信息
 * @param {string} id - 订单 ID
 */
export const getOrderPayInfo = id => {
  if (!id) {
    return Promise.reject('操作订单详情需要订单 ID')
  }
  return request.post(
    GlobalConfig.APIs.getOrderPayInfo,
    {
      token: GlobalEnv.loginInfo.token,
      order_id: id,
    },
    {
      header: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    }
  )
}

export const getPayStatus = out_trade_id => {
  if (!out_trade_id) {
    return Promise.reject('操作订单信息')
  }
  return post(
    GlobalConfig.APIs.getPayStatus,
    {
      out_trade_id,
      token: GlobalEnv.loginInfo.token,
    },
    {
      needSign: true,
      emulateJSON: true,
      giveUpNineChapter: true,
    }
  )
}

// https://cooper.didichuxing.com/docs/sheet/2200002709209
export const ORDER_ERR_STATUS = {
  OrderClosed: 12142, // 订单已关闭
  NoInCrowd: 13313, // 不在人群
  NotExistPhone: 12143, // 手机号不存在、没有注册
  NotWaitPayPhone: 13314, // 外部渠道购买手机号与已有订单不符
  BuyLimit: 12012, // 此商品最多可购买1次，您已达到购买上限
  GoodsOffline: 11004, // 商品已下线
  SearchCouponFail: 44001, // 查询券批次信息失败
  GoodsNone: 12141, // 购买人太多了，商品已抢光
  OrderOver: 13315, // 下单超过10次不支付
  OrderOverLock: 13316, // 下单2次锁10min
}
